import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

const Footer = () => {
	return (
		<footer className='ft'>
			<div className='container'>
				<div className='ft-brand'>
					<img src={logo} alt='Champawati logo' />
					<div>
						<h4>Champawati Saving &amp; Credit Co-operative Ltd.</h4>
						<p>Machhapokhari, Kathmandu-16</p>
						<p>
							Phone: <a href='tel:015906224'>01-5906224</a>,{" "}
							<a href='tel:9851279532'>9851279532</a>
						</p>
						<p>
							Email:{" "}
							<a href='mailto:champawatisaving@gmail.com'>
								champawatisaving@gmail.com
							</a>
						</p>
						<p>Sun–Fri, 10am–5pm (except public holidays)</p>
					</div>
				</div>
				<div>
					<h4>Quick links</h4>
					<ul>
						<li>
							<Link to='/profile'>About us</Link>
						</li>
						<li>
							<Link to='/services'>Services</Link>
						</li>
						<li>
							<Link to='/notices'>Notices</Link>
						</li>
						<li>
							<Link to='/boardmembers'>Board members</Link>
						</li>
						<li>
							<Link to='/contact'>Contact</Link>
						</li>
					</ul>
				</div>
				<div className='ft-copy'>
					&copy; {new Date().getFullYear()} Champawati Saving and Credit
					Co-operative Ltd. All rights reserved.
				</div>
			</div>
		</footer>
	);
};

export default Footer;
